module.exports = __webpack_public_path__ + "img/P100.ba22e026.jpg";